
import { defineComponent, onBeforeMount, ref } from 'vue';
import message from 'ant-design-vue/lib/message';
import storeApp from '@/store/storeApp';
import Icone from '@/core/components/UI/Icone.vue';
import GerenciadorAutenticacao from '../gerenciadores/GerenciadorAutenticacao';
import router from '@/router';
import ServicoApp from '@/servicos/ServicoApp';
import { useAppBase } from '../composables/AppBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { ETipoIntegracao } from '@/models/Enumeradores/ETipoIntegracao';
import ServicoUsuario from '@/servicos/ServicoUsuario';
import { ETipoVinculo } from '@/models/Enumeradores/ETipoVinculo';

export default defineComponent({
  name: 'AppLayout',
  props: {
    msg: String,
  },
  components: {
    Icone,
  },
  setup() {
    const { apresentarMensagemSucesso } = useAppBase();

    storeApp.mutations.atualizarCarregando(true);
    const servicoApp = new ServicoApp();
    const gerenciadorAutenticacao = new GerenciadorAutenticacao();
    const layoutMobile = ref(false);

    onBeforeMount(async () => {
      if (!gerenciadorAutenticacao.verificaAutenticacao()) {
        router.push({ name: 'Login' });
      }

      storeApp.mutations.atualizarParceiroAutenticado(storeApp.getters.obterParceiroAutenticado(gerenciadorAutenticacao.obtemIdentificadorParceiro()));
      document.documentElement.style.setProperty('--primary', storeApp.state.parceiroAutenticado.corPrimaria);
      document.documentElement.style.setProperty('--primary-light', storeApp.state.parceiroAutenticado.corSecundaria);
      document.documentElement.style.setProperty('--primary-dark', storeApp.state.parceiroAutenticado.corEscura);

      gerenciadorAutenticacao.obtemIdentificadorParceiro();
      if (gerenciadorAutenticacao.atualizarToken()) {
        const retornoAutenticacao = await servicoApp.atualizarToken();
        if (retornoAutenticacao.autenticado) {
          gerenciadorAutenticacao.salvarDadosAutenticacao(retornoAutenticacao.token, retornoAutenticacao.dataExpiracao.toString());
        }
      }
      const configuracaoPlataforma = await servicoApp.obterConfiguracoes();
      storeApp.mutations.atualizarConfiguracaoPlataforma(configuracaoPlataforma);

      const integracoes = await servicoApp.obterIntegracoesErp();
      storeApp.mutations.atualizarIntegracoesErp(integracoes);

      const dadosUsuarioAutenticado = await servicoApp.obterDadosUsuarioAutenticado();
      storeApp.mutations.atualizarUsuarioAutenticado(dadosUsuarioAutenticado);
      storeApp.mutations.atualizarZonaRota('');
      storeApp.mutations.atualizarForcaVendas(false);
      if (UtilitarioGeral.validaLista(storeApp.state.integracoesErp)) {
        if (storeApp.state.integracoesErp[0].codigo > 0 && storeApp.state.integracoesErp[0].tipo === ETipoIntegracao.ErpVisualSAEF) {
          const vinculosUsuario = await new ServicoUsuario().obterVinculos(dadosUsuarioAutenticado.codigo);
          if (UtilitarioGeral.validaLista(vinculosUsuario)) {
            const indexVinculoVendedor = vinculosUsuario.findIndex((c) => c.tipo === ETipoVinculo.UsuarioVendedor);
            if (indexVinculoVendedor >= 0) {
              storeApp.mutations.atualizarCodigoVendedor(vinculosUsuario[indexVinculoVendedor].codigoRelacionado);
              storeApp.mutations.atualizarForcaVendas(true);
            }
            const indexVinculo = vinculosUsuario.findIndex((c) => c.tipo === ETipoVinculo.UsuarioVendedorZona);
            if (indexVinculo >= 0) {
              storeApp.mutations.atualizarZonaRota(vinculosUsuario[indexVinculo].codigoRelacionado);
              storeApp.mutations.atualizarForcaVendas(true);
            }
          }
        }
      }
      storeApp.mutations.atualizarCarregando(false);
    });

    async function deslogar() {
      const retornoAutenticacao = await servicoApp.deslogar();
      if (!retornoAutenticacao.autenticado) {
        gerenciadorAutenticacao.removerDadosAutenticacao();
        router.push({ name: 'Login' });
      } else {
        message.warn(retornoAutenticacao.mensagem);
      }
    }

    function acessarMenu(rota: string) {
      router.push({ name: rota });
    }

    async function limparCache() {
      apresentarMensagemSucesso('Limpeza de cache iniciada com sucesso! Em breve todo conteúdo vai estar atualizado.');
      await servicoApp.limparCache();
    }

    return {
      selectedKeys: ref(['1']),
      collapsed: ref(false),
      storeApp,
      current: ['1'],
      acessarMenu,
      deslogar,
      limparCache,
    };
  },
});
